define(
	'NVT.MyRegisterColleague.MyRegisterColleague'
,   [
		'NVT.MyRegisterColleague.MyRegisterColleague.View',

		'NVT.MyRegisterColleague.MyTermsConditions.View',

		'NVT.MyRegisterColleague.MyPendingReview.View',
				
		'NVT.MyRegisterColleague.MyPromotion.View',

		'NVT.ssg_funded.ssgfunded.View'
	]
,   function (
		MyRegisterColleagueView,

		MyTermsConditionsView,

		MyPendingReviewView,
		
		MyPromotionView,

		ssgfundedView

	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var pdp =  container.getComponent('PDP');

			if(layout)
			{
				layout.addChildView('customMyRegisterColleagueView', function() { 
					if(pdp.getItemInfo().item.custitem_nus_wizapitype === 'SSG')
					{
						return new ssgfundedView({ container: container }); // 
					}
					else{
						return new MyRegisterColleagueView({ container: container });
					}
				});

				layout.addChildView("cct-view-termcondition", function() { 
					return new MyTermsConditionsView({ container: container });
				});

				layout.addChildView("cct-view-pending-review", function() { 
					return new MyPendingReviewView({ container: container });
				});

				layout.addChildView('CartPromocodeFrom', function() { 
					return new MyPromotionView({ container: container });
				});
			}

			if (pdp) {
				pdp.on("afterShowContent", function () {
					var itemDetail = pdp.getItemInfo();
					jQuery("div[data-view='Options.Collection']").css("display",'none !important');
					jQuery("div[data-view='Quantity']").css("display",'none');
					jQuery("#custcol_event_register_name-container").css("display",'none');
					jQuery("#custcol_nus_ems_patemail-container").css("display",'none');						
					jQuery("#custcol_nus_partjobtitle-container").css("display",'none');						
					jQuery("#custcol_nus_partphonno-container").css("display",'none');						
					jQuery("#custcol_nus_ems_participant-container").css("display",'none');						
					jQuery("#custcol_nus_ref_participantid-container").css("display",'none');						
					// start ssg enrollment configuration				
					jQuery("#custcol_nus_wizlearn_jason-container").css("display",'none');
					jQuery("#custcol_nus_reg_lingrant-container").css("display",'none');
					jQuery("#custcol_nus_get_approve_grand_inform-container").css("display",'none');
					// End
					if(itemDetail.item && itemDetail.item.itemtype != "GiftCert")
					{
						jQuery("div[data-view='Product.Price']").css("display",'none !important');
						jQuery(".product-details-full-product-options-container").css("display",'none !important');
						jQuery(".product-details-full-actions").css("display",'none !important');
						jQuery(".myregistercolleague-info-card:not(:last)").remove();
						jQuery("div[data-view='MainActionView']").remove();
						jQuery(".product-details-options-selector").css("display",'none !important');
						jQuery("#GIFTCERTRECIPIENTEMAIL-container").css("display",'none');
					}
					else{
						jQuery(".myregistercolleague-info-card").remove();
						jQuery("div[data-view='Product.Price']").css("display",'block !important');
						jQuery(".product-details-full-product-options-container").css("display",'block !important');
						jQuery(".product-details-full-actions").css("display",'block !important');
						jQuery(".product-details-options-selector").css("display",'block');

					}
				});
			}		


		}
	};
});
